import { render } from "./Total_Collections.vue?vue&type=template&id=9b3a174a&scoped=true"
import script from "./Total_Collections.vue?vue&type=script&lang=js"
export * from "./Total_Collections.vue?vue&type=script&lang=js"

import "./Total_Collections.vue?vue&type=style&index=0&id=9b3a174a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b3a174a"]])

export default __exports__